:host {
  display: block;
}

.signin-link {
  color: #2e5276;
  cursor: pointer;
  font-family: "acumin-pro", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: .2px;
  text-decoration: none;
}

.signin-link:hover {
  color: #457ab0 !important;
  text-decoration: underline !important;
}

@media(min-width: 480px) {
  .signin-link {
    font-size: 20px;
  }
}

@media(min-width: 1250px) {
  .signin-link {
    font-size: 26px;
  }
}